import { getDataObjectPanelNavigationParams } from '@atlas-frontend/sdk';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { path, UiPathName } from '../../paths';
import { useNavigateTo } from '../../paths/useNavigateTo';

export const useDataObjectActionHandlers = (
  uiPathName: UiPathName<'inputDataObjectView' | 'outputDataObjectView'>,
) => {
  const { id } = useParams() as { id: string | number };
  const navigateToEntityView = useNavigateTo(path[uiPathName], { id });
  const navigateToEntityEdit = useNavigateTo(
    path[
      uiPathName === 'inputDataObjectView'
        ? 'inputDataObjectEdit'
        : 'outputDataObjectEdit'
    ],
  );
  const navigateToListView = useNavigateTo(
    path[
      uiPathName === 'inputDataObjectView'
        ? 'inputDataObjectDirectory'
        : 'outputDataObjectDirectory'
    ],
  );

  const handleAction = useCallback(
    (action: 'success' | 'cancel', params?: { id: number; mode?: string }) => {
      const mode = params?.mode ?? 'edit';
      if (params?.id && mode === 'edit') {
        navigateToEntityView(
          { ...getDataObjectPanelNavigationParams(), id: params.id },
          { state: { saved: action, noBlocker: action === 'success' } },
        );
      } else if (params?.id && action === 'success') {
        navigateToEntityEdit(
          { id: params.id },
          { state: { saved: action, noBlocker: action === 'success' } },
        );
      } else {
        navigateToListView(undefined, { state: { saved: action } });
      }
    },
    [navigateToEntityView, navigateToListView, navigateToEntityEdit],
  );

  return {
    handleSuccess: useCallback(
      (params?: { id: number; mode?: string }) =>
        handleAction('success', params),
      [handleAction],
    ),
    handleCancel: useCallback(
      (params?: { id: number; mode?: string }) =>
        handleAction('cancel', params),
      [handleAction],
    ),
  };
};
